import { Trigger } from '@radix-ui/react-tabs';
import { ComponentPropsWithRef } from 'react';
import { TabsTab } from './tabs-tab';

type Props = ComponentPropsWithRef<typeof Trigger>;
export const TabsTrigger = ({ children, ...props }: Props) => {
    return (
        <Trigger asChild {...props}>
            <TabsTab>{children}</TabsTab>
        </Trigger>
    );
};
